import { Icon as e } from "../icon/index.js";
import { cn as t } from "../cn.js";
import { commandBarBackdropStyles as n, commandBarContentStyles as r, commandBarEmptyStyles as i, commandBarGroupHeadingStyles as a, commandBarGroupStyles as o, commandBarInputStyles as s, commandBarItemIconStyles as c, commandBarItemShortcutStyles as l, commandBarItemStyles as u, commandBarItemTextStyles as d, commandBarListStyles as f, commandBarPositionerStyles as p, commandBarSeparatorStyles as m, commandBarTriggerStyles as h } from "./styles.js";
import * as g from "react";
import { jsx as _, jsxs as v } from "react/jsx-runtime";
import { Portal as y } from "@ark-ui/react/portal";
import { Dialog as b } from "@ark-ui/react/dialog";
// src/design/command-bar/index.tsx
var x = ({ children: e, ...t }) => /* @__PURE__ */ _(b.Root, {
	...t,
	children: e
}), S = g.forwardRef(({ children: e, variant: n = "default", size: r = "md", icon: i, shortcut: a, className: o, asChild: s, shortcutClassName: c = "", ...l }, u) => s ? /* @__PURE__ */ _(b.Trigger, {
	asChild: !0,
	children: e
}) : /* @__PURE__ */ _(b.Trigger, {
	asChild: !0,
	children: /* @__PURE__ */ v("button", {
		ref: u,
		className: t(h({
			variant: n,
			size: r
		}), o),
		...l,
		children: [
			i,
			/* @__PURE__ */ _("span", {
				className: "flex-1 text-left",
				children: e
			}),
			a && /* @__PURE__ */ _("kbd", {
				className: t("ml-auto text-xs font-mono text-muted-foreground", c),
				children: a
			})
		]
	})
}));
S.displayName = "CommandBarTrigger";
var C = ({ className: e, ...r }) => /* @__PURE__ */ _(b.Backdrop, {
	className: t(n(), e),
	...r
}), w = ({ children: e, className: n, ...r }) => /* @__PURE__ */ _(b.Positioner, {
	className: t(p(), n),
	...r,
	children: e
}), T = ({ children: e, className: n, ...i }) => /* @__PURE__ */ _(b.Content, {
	className: t(r(), n),
	...i,
	children: e
}), E = g.forwardRef(({ size: e = "md", className: n, ...r }, i) => /* @__PURE__ */ _("input", {
	ref: i,
	type: "text",
	className: t(s({ size: e }), n),
	...r
}));
E.displayName = "CommandBarInput";
var D = ({ children: e, className: n, ...r }) => /* @__PURE__ */ _("div", {
	className: t(f(), n),
	...r,
	children: e
}), O = ({ children: e, className: n }) => /* @__PURE__ */ _("div", {
	className: t(i(), n),
	children: e
}), k = ({ heading: e, children: t }) => /* @__PURE__ */ v("div", {
	className: o(),
	children: [e && /* @__PURE__ */ _("div", {
		className: a(),
		children: e
	}), t]
}), A = g.forwardRef(({ children: n, icon: r, shortcut: i, disabled: a, selected: o, onSelect: s, size: f = "md", className: p, shortcutClassName: m, ...h }, y) => /* @__PURE__ */ v("div", {
	ref: y,
	role: "option",
	"aria-selected": o,
	"aria-disabled": a,
	"data-highlighted": o ? "" : void 0,
	"data-selected": o ? "" : void 0,
	"data-disabled": a ? "" : void 0,
	className: t(u({ size: f }), p),
	onClick: a ? void 0 : s,
	...h,
	children: [
		r && (typeof r == "string" ? /* @__PURE__ */ _(e, {
			name: r,
			className: c()
		}) : g.createElement(r, { className: c() })),
		/* @__PURE__ */ _("span", {
			className: d(),
			children: n
		}),
		i && /* @__PURE__ */ _("div", {
			className: l(),
			children: Array.isArray(i) ? i.map((e, n) => /* @__PURE__ */ _("kbd", {
				className: t("px-1.5 py-0.5 bg-muted rounded text-xs", m),
				children: e
			}, n)) : /* @__PURE__ */ _("kbd", {
				className: t("px-1.5 py-0.5 bg-muted rounded text-xs", m),
				children: i
			})
		})
	]
}));
A.displayName = "CommandBarItem";
var j = Object.assign(x, {
	Trigger: S,
	Backdrop: C,
	Positioner: w,
	Content: T,
	Input: E,
	List: D,
	Empty: O,
	Group: k,
	Item: A,
	Separator: ({ className: e, ...n }) => /* @__PURE__ */ _("div", {
		role: "separator",
		className: t(m(), e),
		...n
	}),
	Portal: y
}), M = () => {
	let [e, t] = g.useState(!1);
	return g.useEffect(() => {
		let e = (e) => {
			(e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k" && (e.preventDefault(), t((e) => !e));
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, []), {
		open: e,
		setOpen: t
	};
};
export { j as CommandBar, M as useCommandBar };

//# sourceMappingURL=index.js.map